<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="640px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div slot="title" class="dialog-title">
      <span>
        <strong>故障台账导出</strong>
        <small>选择数据在 Excel 中的组织方式</small>
      </span>
    </div>

    <div class="export-dialog-body">
      <div class="intro-panel">
        <i class="el-icon-info" />
        <div>
          <div class="intro-title">导出范围已按当前筛选条件确定</div>
          <div class="intro-text">下面的选项只影响 Sheet 拆分方式，不会改变导出的故障数据。</div>
        </div>
      </div>

      <div class="section-heading">
        <span>选择拆分方式</span>
        <em>{{ selectedModeLabel }}</em>
      </div>

      <div class="option-list">
        <div
          class="export-option"
          :class="{ 'is-active': form.splitStatus }"
          @click="form.splitStatus = !form.splitStatus"
        >
          <div class="option-icon status-icon"><i class="el-icon-s-operation" /></div>
          <div class="option-content">
            <div class="option-title">按处理状态拆分</div>
            <div class="option-desc">将待处理和已完成的故障分别放入不同 Sheet，便于跟进处理进度。</div>
          </div>
          <el-checkbox v-model="form.splitStatus" @click.native.stop />
        </div>

        <div
          class="export-option"
          :class="{ 'is-active': form.splitRegion }"
          @click="form.splitRegion = !form.splitRegion"
        >
          <div class="option-icon region-icon"><i class="el-icon-map-location" /></div>
          <div class="option-content">
            <div class="option-title">按所属大区拆分</div>
            <div class="option-desc">按一级所属大区分别生成 Sheet，方便各区域独立查看和分发。</div>
          </div>
          <el-checkbox v-model="form.splitRegion" @click.native.stop />
        </div>
      </div>

      <div class="preview-panel">
        <div class="preview-heading">
          <span><i class="el-icon-document" /> Sheet 预览</span>
          <span class="preview-note">示例名称</span>
        </div>
        <div class="sheet-list">
          <span v-for="sheet in sheetPreview" :key="sheet" class="sheet-item">
            <i class="el-icon-tickets" />{{ sheet }}
          </span>
        </div>
      </div>

      <div class="file-name-tip">
        <i class="el-icon-paperclip" /> 文件将保存为“故障列表 + 随机串.xlsx”，避免重复下载时相互覆盖。
      </div>
    </div>

    <div slot="footer">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确认导出</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FaultExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        splitStatus: false,
        splitRegion: false
      }
    };
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible;
      },
      set (value) {
        this.$emit('update:visible', value);
      }
    },
    selectedModeLabel () {
      if (this.form.splitStatus && this.form.splitRegion) {
        return '所属大区 + 处理状态';
      }
      if (this.form.splitStatus) {
        return '处理状态';
      }
      if (this.form.splitRegion) {
        return '所属大区';
      }
      return '不拆分';
    },
    sheetPreview () {
      if (this.form.splitStatus && this.form.splitRegion) {
        return ['大区1-待处理', '大区1-已维修完成', '大区2-待处理', '大区2-已维修完成'];
      }
      if (this.form.splitStatus) {
        return ['待处理', '已维修完成'];
      }
      if (this.form.splitRegion) {
        return ['大区1-故障列表', '大区2-故障列表'];
      }
      return ['故障列表'];
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    handleConfirm () {
      this.$emit('confirm-export', { ...this.form });
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.form = { splitStatus: true, splitRegion: false };
      }
    }
  }
};
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  color: #303133;
}

.dialog-title strong,
.dialog-title small {
  display: block;
}

.dialog-title strong {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.dialog-title small {
  margin-top: 2px;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.export-dialog-body {
  color: #303133;
}

.intro-panel {
  display: flex;
  align-items: flex-start;
  padding: 12px 14px;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  background: #f4f9ff;
  color: #409eff;
}

.intro-panel > i {
  margin: 2px 8px 0 0;
  font-size: 16px;
}

.intro-title {
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.intro-text,
.option-desc,
.file-name-tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 10px;
  font-size: 13px;
  font-weight: 600;
}

.section-heading em {
  padding: 2px 8px;
  border-radius: 10px;
  background: #f0f2f5;
  color: #606266;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.option-list {
  display: grid;
  gap: 10px;
}

.export-option {
  display: flex;
  align-items: center;
  min-height: 72px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;
}

.export-option:hover {
  border-color: #b3d8ff;
  background: #f8fbff;
}

.export-option.is-active {
  border-color: #409eff;
  background: #f4f9ff;
  box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.08);
}

.option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  margin-right: 12px;
  border-radius: 8px;
  font-size: 17px;
}

.status-icon {
  background: #fdf6ec;
  color: #e6a23c;
}

.region-icon {
  background: #f0f9eb;
  color: #67c23a;
}

.option-content {
  flex: 1;
  min-width: 0;
}

.option-title {
  margin-bottom: 3px;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.export-option ::v-deep .el-checkbox {
  margin-left: 12px;
}

.preview-panel {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #f7f8fa;
}

.preview-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
}

.preview-heading i {
  margin-right: 5px;
  color: #909399;
}

.preview-note {
  color: #c0c4cc;
  font-weight: 400;
}

.sheet-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.sheet-item {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 9px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 12px;
}

.sheet-item i {
  margin-right: 5px;
  color: #67c23a;
}

.file-name-tip {
  margin-top: 12px;
}

.file-name-tip i {
  margin-right: 4px;
  color: #c0c4cc;
}
</style>
